import { render, staticRenderFns } from "./orderAll.vue?vue&type=template&id=1babcb44&scoped=true&"
import script from "./orderAll.vue?vue&type=script&lang=js&"
export * from "./orderAll.vue?vue&type=script&lang=js&"
import style0 from "./orderAll.vue?vue&type=style&index=0&id=1babcb44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1babcb44",
  null
  
)

export default component.exports